import React from 'react';
import { Wordmark } from './BrandArtwork';
import { FooterCatVignette } from './FooterCatVignette';
import { navLinks } from '../data/site';
export function SiteFooter() {
  return <footer className="relative min-h-[620px] overflow-hidden border-t border-ink/10 bg-cream md:min-h-[640px] lg:min-h-[660px]" data-id="element-135" data-mp="3mh9i07pj8jg1">
      <FooterCatVignette data-id="element-136" data-mp="3hherw6dkzxw1" />

      <div className="relative z-10 mx-auto flex min-h-[620px] max-w-content flex-col px-5 pb-8 pt-16 md:min-h-[640px] md:px-8 lg:min-h-[660px] lg:px-10" data-id="element-137" data-mp="3hi6bsjxtg76h">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12" data-id="element-138" data-mp="38h8eekhvuxwv">
          <div className="md:col-span-6" data-id="element-139" data-mp="38k4eaedajwny">
            <Wordmark className="h-8 w-auto md:h-10" data-id="element-140" data-mp="33jq52szyegoc" />
            <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-ink/75" data-id="element-141" data-mp="33ki0a2pn2ce3">
              An independent app studio building learning, lifestyle and gaming apps for U.S. users,
              with quality and feedback at the center.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 md:col-span-6 md:grid-cols-2" data-id="element-142" data-mp="wsqs08x0liqc">
            <nav aria-label="Footer" data-id="element-143" data-mp="15q2aeogcj497">
              <h2 className="text-[11px] font-medium uppercase tracking-[0.2em] text-ink/55" data-id="element-144" data-mp="15t80a5wsua5z">
                Sections
              </h2>
              <ul className="mt-4 space-y-1" data-id="element-145" data-mp="vt7gkiv0ps19">
                {navLinks.map(link => <li key={link.href} data-id="element-146" data-mp="10r8uyqhi136e">
                    <a href={link.href} className="inline-flex min-h-[40px] items-center text-[15px] text-ink/80 transition-colors duration-150 ease-out hover:text-ink" data-id="element-147" data-mp="10saivvjm5k5j">
                      {link.label}
                    </a>
                  </li>)}
                <li data-id="element-148" data-mp="1eppan6xca40o">
                  <a href="#top" className="inline-flex min-h-[40px] items-center text-[15px] text-ink/80 transition-colors duration-150 ease-out hover:text-ink" data-id="element-149" data-mp="1jq4os0pg3fjp">
                    Back to top
                  </a>
                </li>
              </ul>
            </nav>

            <div data-id="element-150" data-mp="2m1mnc7vm8gox">
              <h2 className="text-[11px] font-medium uppercase tracking-[0.2em] text-ink/55" data-id="element-151" data-mp="2m24qzpklxx6v">
                Studio
              </h2>
              <ul className="mt-4 space-y-3 text-[15px] text-ink/80" data-id="element-152" data-mp="2d1zj7ebi4ws6">
                <li data-id="element-153" data-mp="2d4cbolevypjh">blackcometlabs.io</li>
                <li data-id="element-154" data-mp="283obb94rowcl">Learning · Lifestyle · Gaming</li>
                <li data-id="element-155" data-mp="28594aubfo78c">Built for U.S. users</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-auto pt-20" data-id="element-156" data-mp="235wimcwat67c">
          <div className="h-px w-full bg-ink/15" aria-hidden="true" data-id="element-157" data-mp="1yd3d3mt09tu7" />
          <p className="pr-16 pt-5 text-xs font-medium text-ink/65" data-id="element-158" data-mp="1te8lbvd28uxy">
            © {new Date().getFullYear()} Black Comet Labs. Apps with purpose. Built with care.
          </p>
        </div>
      </div>
    </footer>;
}